import * as React from "react"

const Unlocked = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M5.5 5.11A2.59 2.59 0 0 1 8.06 2.5c.79 0 1.49.36 1.96.92l.32.39.77-.64-.32-.39A3.54 3.54 0 0 0 8.06 1.5 3.59 3.59 0 0 0 4.5 5.11V6H2v8h12V6H5.5v-.89ZM3 7h10v6H3V7Z" />
  </svg>
)

export default Unlocked
